/* eslint-disable */
import React, { useState, useCallback, useEffect } from "react";
import { Input, Select, FileUpload, Button, BrandIconSpinner } from "components";
import { ExperienceList, GenderList } from "assert/OptionList";
import { JobApply, jobsubmit } from "redux/features/PostJobSlice";
import { useDispatch, useSelector } from "react-redux";
import { Notification } from "components/CustomNotification";
import { t } from "i18next";
import { TemplatesStyle } from "./CreateForm.style";
import AutoComplete from "components/AutoComplete";
import { DialogActions, IconButton } from "@mui/material";


import { ReactComponent as BackArrow } from "assert/images/Common/backArrow.svg";
import { ReactComponent as ForwardArrow } from "assert/images/Common/forwardArrow.svg";
import { ReactComponent as Add } from 'assert/images/Profile/add.svg';
import { EmailRegex } from "utils/helper";

function Template1({ closeModal, handleSelectTemplate, handleSuccessClose, apply, jobState, setInitialState, setStateChangedValue }) {
  const dispatch = useDispatch();
  const { getProfile } = useSelector((state) => state?.ProfileSlice);

  const [disable, setdisable] = useState(null);
  const [isNextPage, setIsNextPage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [newSkill, setNewSkill] = useState('');

  const [state, setState] = useState({
    FullName: "",
    Email: "",
    Gender: "",
    Phone: "",
    Portfolio: "",
    HigestDegree: "",
    Discipline: "",
    AnyThingElse: "",
    resume: "",
    coverLetter: "",
    skill: "",
    experience: "",
  });

  const [errMsg, setErrmsg] = useState({
    FullName: "",
    Email: "",
    Gender: "",
    Phone: "",
    resume: "",
    skill: "",
    experience: "",
  });

  useEffect(() => {
    setInitialState && setInitialState(JSON.stringify(state));
  }, [])

  const handleChange = useCallback((data, name) => {
    setStateChangedValue(JSON.stringify({ ...state, [name]: data?.target?.value || data }));
    setState((prevState) => ({
      ...prevState,
      [name]: data?.target?.value || data,
    }));
  }, []);

  useEffect(() => {
    apply ? setdisable(false) : setdisable(true);
  }, [apply]);

  const handleValidation = () => {
    Object.keys(errMsg).forEach((data) => (errMsg[data] = state[data] === "" ? "Field Required" : ""));
    setErrmsg((prevState) => ({
      ...prevState,
    }));
    setState((prevState) => ({
      ...prevState,
    }));
  };

  const Submit = () => {
    handleValidation();
    const validation = Object.keys(errMsg).every((data) => {
      return errMsg[data] === "";
    });
    if (validation) {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("JobPostId", jobState?.jobPostId);
      formData.append("jobPostedBy", jobState?.jobPostedUserInfo?.userId);
      formData.append("userId", getProfile?.userId);
      formData.append("skill", JSON.stringify(state.skill));
      formData.append("experience", state.experience);
      formData.append("userEmail", getProfile?.userEmail);
      formData.append(
        "data",
        JSON.stringify({
          FullName: state.FullName,
          Email: state.Email,
          Gender: state.Gender,
          Phone: state.Phone,
          Portfolio: state.Portfolio,
          HigestDegree: state.HigestDegree,
          Discipline: state.Discipline,
          AnyThingElse: state.AnyThingElse,
        })
      );
      formData.append("resume", state.resume?.[0]);
      if (state.coverLetter?.[0]) {
        formData.append("coverLetter", state.coverLetter?.[0]);
      }
      dispatch(JobApply(formData))
        .then((res) => {
          handleSuccessClose(jobState?.jobPostId);
          dispatch(jobsubmit(""));
          Notification("success", res?.data?.message);
          setIsLoading(false);
        })
        .catch(() => {
          Notification("warning", "Something went wrong");
          setIsLoading(false);
        });
    }
    setErrmsg((prevState) => ({
      ...prevState,
    }));
  };

  const handleNextPage = () => {
    let isFilledAllFields = false;
    const firstPageFields = ["FullName", "Gender", "Phone"];
    firstPageFields?.forEach((value) => {
      if (!isFilledAllFields && state[value] === "") {
        isFilledAllFields = true;
      }
      errMsg[value] = state[value] === "" ? "Field Required" : "";
    });
    if (!state.Email.match(EmailRegex)) {
      errMsg.Email = 'Email is Invalid';
      isFilledAllFields = true;
    }
    else errMsg.Email = '';
    setErrmsg((prevState) => ({
      ...prevState,
    }));
    if (!isFilledAllFields) {
      setIsNextPage(true);
    }
  };

  const handleCloseModal = () => {
    handleSelectTemplate(JSON.stringify(state));
  };

  const handleAddSkill = () => {
    if (newSkill.trim() !== '') {
      const updatedSkills = [...state.skill, newSkill];
      handleChange(updatedSkills, 'skill');
      setNewSkill('');
    }
  };

  return (
    <TemplatesStyle>
      <BrandIconSpinner loading={isLoading} />
      {!apply && <h3>{t('Job.Step1')}</h3>}
      {(!isNextPage || !apply) && (
        <>
          <div className="field-wrap">
            <Input
              label={t('Job.FullName')}
              value={state.FullName}
              required
              onChange={(data) => handleChange(data, "FullName")}
              disabled={disable}
              errMsg={errMsg.FullName}
            />
            <Select
              label={t('Job.Gender')}
              Options={GenderList}
              value={state.Gender}
              required
              disabled={disable}
              errMsg={errMsg.Gender}
              onChange={(data) => handleChange(data, "Gender")}
            />
          </div>
          <div className="field-wrap">
            <Input
              label={t('Job.Email')}
              required
              value={state.Email}
              disabled={disable}
              errMsg={errMsg.Email}
              onChange={(data) => handleChange(data, "Email")}
            />
            <Input
              label={t('Job.Phone')}
              required
              type="text"
              value={state.Phone}
              disabled={disable}
              errMsg={errMsg.Phone}
              maxLimit={20}
              onChange={(data) => {
                const sanitizedValue = data.replace(/[^0-9+]/g, "");
                handleChange(sanitizedValue, "Phone")
              }}
            />
          </div>
          <div className="field-wrap">
            <Input
              label={t('Job.HighestDegree')}
              value={state.HigestDegree}
              onChange={(data) => handleChange(data, "HigestDegree")}
              disabled={disable}
            />
            <Input
              label={t('Job.Discipline')}
              value={state.Discipline}
              onChange={(data) => handleChange(data, "Discipline")}
              disabled={disable}
            />
          </div>
          <div className="field-wrap">
            <Input
              label={t('Job.Portfolio')}
              value={state.Portfolio}
              disabled={disable}
              onChange={(data) => handleChange(data, "Portfolio")}
            />
          </div>
          <div className="field-comment">
            <Input
              multiline
              minRows={4}
              maxLimit={600}
              label={t('Job.AnythingShare')}
              value={state.AnyThingElse}
              disabled={disable}
              onChange={(data) => handleChange(data, "AnyThingElse")}
            />
          </div>
        </>
      )}
      {!apply && <h3>{t('Job.Step2')}</h3>}
      {(isNextPage || !apply) && (
        <>
          <div className="field-wrap">
            <FileUpload
              label={t('Job.Resume')}
              required
              value={state.resume}
              handleFileSRC={(data) => handleChange(data, "resume", "file")}
              errMsg={errMsg.resume}
              disabled={disable}
            />
            <FileUpload
              label={t('Job.CoverLetter')}
              value={state.coverLetter}
              disabled={disable}
              handleFileSRC={(data) => handleChange(data, "coverLetter", "file")}
            />
          </div>
          {apply && (
            <div>
              <div className="static-field-wrap">
                <div className="static-skills-container">
                  <AutoComplete
                    freeSolo
                    multiple
                    required
                    label={t('Job.Skills')}
                    value={state.skill}
                    errMsg={errMsg.skill}
                    onChange={(data) => handleChange(data, "skill")}
                    autoCompleteInputValue={newSkill}
                    onInputChange={(_, newInputValue) => setNewSkill(newInputValue)}
                    Options={[]}
                    textPlaceholder={t('Job.EnterAdd')}
                  />
                  <IconButton
                    className="static-skill-icon-btn"
                    aria-label="toggle password visibility"
                    onClick={handleAddSkill}
                    edge="end"
                    size="small"
                  >
                    <Add />
                  </IconButton>
                </div>
                <AutoComplete
                  required
                  label={t('Job.TotalExperience')}
                  value={state.experience}
                  errMsg={errMsg.experience}
                  onChange={(data) => handleChange(data, "experience")}
                  Options={ExperienceList}
                />
              </div>
              <div className="static-field-helper">
                {t('Job.NoteText')}
              </div>
            </div>
          )}
        </>
      )}
      <DialogActions>
        {isNextPage && <Button variant="text" label={t('Job.Back')} onClick={() => setIsNextPage(false)} startIcon={<BackArrow />} />}
        <Button
          variant="text"
          label={apply ? (!isNextPage ? t('Job.Next') : t('Job.Submit')) : t('Job.SelectTemplate1')}
          onClick={() => (apply ? (!isNextPage ? handleNextPage() : Submit()) : handleCloseModal())}
          endIcon={apply && !isNextPage ? <ForwardArrow /> : <></>}
        />
        <Button variant="text" label={t('Job.Cancel')} customStyles="cancel-btn" onClick={closeModal} />
      </DialogActions>
    </TemplatesStyle>
  );
}

export default Template1;